import { Directive, ElementRef, OnInit, Input } from '@angular/core';
import * as Jquery from 'jquery';

@Directive({ selector: '[setBase64ToModel]' })
export class SetBase64ToModelDirective implements OnInit {
    @Input() setBase64ToModel;
    @Input() rootModel;

    constructor(private el: ElementRef) {}

    ngOnInit() {
		Jquery(this.el.nativeElement).change(this.readUrl.bind(this));
    }

    readUrl() {
		if (this.el.nativeElement.files && this.el.nativeElement.files[0]) {
			const reader = new FileReader();
			reader.onload = (e: any) => {
				this.rootModel[this.setBase64ToModel] = e.target.result.split('base64,')[1];
			}

			reader.readAsDataURL(this.el.nativeElement.files[0]);
		} else {
			this.rootModel[this.setBase64ToModel] = null;
		}
    }
}
